module.exports = __webpack_public_path__ + "static/media/telegramicon.3f32a0ca.svg";